<div class="row best-performing-container" *ngIf="topThreePerformingInfluencer.length > 0">
  <div class="col-md-12 col-sm-12">
    <div class="row top-performing-container">
      <div class="col-sm-4 top-performing-item" *ngFor="let topPerforming of topThreePerformingInfluencer; let i = index" >
        <top-performing-influencer [topPerforming]="topPerforming" [index]="i + 1" [isSortedByReach]="isSortedByReach"></top-performing-influencer>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="best-performing-seperation">
      <div class="best-performing-seperate-line"></div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 best-performing-influencer-table" *ngIf="remaningInfluencerExcludeTopThree.length > 0">
    <div class="d-flex flex-column flex-auto">
      <div class="d-flex flex-row flex-auto roi-header-line">
        <div class="influencer-info-col">
          <div class="d-flex flex-row flex-auto">
            <div class="roi-table-header index-col-header">#</div>
            <div class="roi-table-header influencer-details-col flex-auto">{{'measure.best_performing.header.influencer' | translate}}</div>
            <div class="roi-table-header platform-icon-col"></div>
          </div>
        </div>
        <div class="mentions-col"><div class="roi-table-header">{{'measure.best_performing.header.mentions' | translate}}</div></div>
        <div *ngIf="isSortedByReach" class="reach-col"><div class="roi-table-header reach-header">{{'measure.best_performing.header.reach' | translate}}</div></div>
        <div *ngIf="!isSortedByReach" class="engagement-col"><div class="roi-table-header reach-header">{{'measure.best_performing.header.engagement' | translate}}</div></div>
        <div class="impact-col"><div class="roi-table-header roi-header">{{'measure.best_performing.header.impact' | translate}}</div></div>
      </div>

      <div class="d-flex flex-column flex-auto roi-body-section">
        <div class="d-flex flex-row flex-auto roi-row" *ngFor="let data of remaningInfluencerExcludeTopThree; let i = index"
             [ngClass]="{'odd': i % 2 !== 0, 'even': i % 2 === 0}">
          <div class="d-flex flex-row influencer-info-col">
            <div class="d-flex index-col">{{i+4}}</div>
            <div class="d-flex flex-auto influencer-name-col" (click)="openInfluencerDetails(data.influencerId)">
              <div>
                <achoo-user-avatar [showCountryFlagIcon]="findCountryCode(data) !== null"
                                   [userCountryCode]="findCountryCode(data)"
                                   [userAvatarPicture]="data.influencerImage"
                                   [avatarWidth]="3.5"
                                   [avatarHeight]="3.5"
                                   [countryWidth]="1.15"
                                   [countryHeight]="1.15"
                                   (afterImageLoaded)="callbackImageLoaded()">
                </achoo-user-avatar>
              </div>
              <div class="influencer-name-wrapper">{{data.influencerName}}</div>
            </div>
            <div class="d-flex justify-content-end platform-icon-col">
              <div class="d-flex flex-row">
                <img *ngIf="data.platformBlogs" class="infl-platform" src="assets/images/platform/Blogger.svg" width="20" height="20">
                <img *ngIf="data.platformFacebook" class="infl-platform" src="assets/images/platform/Facebook.svg" width="20" height="20">
                <img *ngIf="data.platformInstagram" class="infl-platform" src="assets/images/platform/Instagram.svg" width="20" height="20">
                <img *ngIf="data.platformYoutube" class="infl-platform" src="assets/images/platform/Youtube.svg" width="20" height="20">
              </div>
            </div>
          </div>
          <div class="d-flex mentions-col">
            <div class="number-col">
              <span placement="bottom" ngbTooltip="{{'info_box.measure.bpi_mention' | translate}}">{{formattedMentionCount(data.mention)}}</span>
            </div>
          </div>
          <div *ngIf="isSortedByReach" class="d-flex reach-col">
            <div class="number-col">
              <span placement="bottom" ngbTooltip="{{'info_box.measure.bpi_reach' | translate}}">{{data.reach | thousandNumberSuffix}}</span>
            </div>
          </div>
          <div *ngIf="!isSortedByReach" class="d-flex engagement-col">
            <div class="number-col">
              <span placement="bottom" ngbTooltip="{{'info_box.measure.bpi_engagement' | translate}}">{{data.engagement | thousandNumberSuffix}}</span>
            </div>
          </div>
          <div class="d-flex impact-col">
            <div class="number-col">
              <span placement="bottom" ngbTooltip="{{'info_box.measure.bpi_impact' | translate}}">{{data.impact * 100 | percentNumberSuffix}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="topThreePerformingInfluencer.length === 0 && !isExportingReport" class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/best-performing-influencer/best-performing-influencer.component.html